import angular from 'angular';

angular.module('gallery.upload').directive('galleryUpload', galleryUpload);

galleryUpload.$inject = [];

function galleryUpload() {
  var directive = {
    bindToController: true,
    controller: 'galleryUploadCtrl',
    controllerAs: 'vm',
    templateUrl: templateUrl,
    link: link,
    restrict: 'E',
    scope: {
      id: '=',
      images: '=?',
      type: '@',
      accept: '@?',
      title: '@?',
      hint: '@?',
    },
  };
  return directive;

  function link(scope, element, attrs, ctrl) {}

  function templateUrl(elem, attrs) {
    return (
      attrs.templateUrl ||
      new URL('app/gallery.upload/gallery.upload.html?raw', import.meta.url)
    );
  }
}
